// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"30":"fc7890ff","485":"348c0b26","548":"bd65ea60","649":"9e88a23b","815":"6d57565f","868":"672bebb5","895":"4072813e"}[chunkId] + ".js";
};